"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDERING = exports.mapConditions = exports.FILTER_CONDITION = exports.DATA_TYPE = void 0;
var tslib_1 = require("tslib");
var locale_1 = tslib_1.__importDefault(require("./locale"));
var DATA_TYPE;
(function (DATA_TYPE) {
    DATA_TYPE["CHOICE"] = "choice";
    DATA_TYPE["BOOLEAN"] = "boolean";
    DATA_TYPE["TEXT"] = "text";
    DATA_TYPE["NUMBER"] = "number";
    DATA_TYPE["ARRAY"] = "array";
    DATA_TYPE["DATETIME"] = "date-time";
    DATA_TYPE["TIME"] = "time";
    DATA_TYPE["DATE"] = "date";
    DATA_TYPE["OBJECT"] = "object";
    DATA_TYPE["NULL"] = "null";
    DATA_TYPE["CUSTOM"] = "custom";
})(DATA_TYPE || (exports.DATA_TYPE = DATA_TYPE = {}));
var FILTER_CONDITION;
(function (FILTER_CONDITION) {
    FILTER_CONDITION["TRUE"] = "true";
    FILTER_CONDITION["FALSE"] = "false";
    FILTER_CONDITION["LTE"] = "lte";
    FILTER_CONDITION["LT"] = "lt";
    FILTER_CONDITION["GTE"] = "gte";
    FILTER_CONDITION["GT"] = "gt";
    FILTER_CONDITION["EQUALS"] = "=";
    FILTER_CONDITION["CONTAINS"] = "contains";
    FILTER_CONDITION["ICONTAINS"] = "icontains";
    FILTER_CONDITION["IN"] = "in";
    FILTER_CONDITION["ISNULL"] = "isnull";
})(FILTER_CONDITION || (exports.FILTER_CONDITION = FILTER_CONDITION = {}));
exports.mapConditions = {
    true: locale_1.default.conditionTrue,
    false: locale_1.default.conditionFalse,
    lte: locale_1.default.conditionLessThanEqual,
    lt: locale_1.default.conditionLessThan,
    gte: locale_1.default.conditionGreaterThanEqual,
    gt: locale_1.default.conditionGreaterThan,
    "=": locale_1.default.conditionEquals,
    icontains: locale_1.default.conditionIcontains,
    contains: locale_1.default.conditionContains,
    search: locale_1.default.conditionSearch,
    iregex: locale_1.default.conditionIregex,
    isnull: locale_1.default.conditionIsnull,
    istartswith: locale_1.default.conditionIstartswith,
    in: locale_1.default.conditionIn,
};
var ORDERING;
(function (ORDERING) {
    ORDERING["ASC"] = "asc";
    ORDERING["DESC"] = "desc";
})(ORDERING || (exports.ORDERING = ORDERING = {}));
//# sourceMappingURL=types.js.map